import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import logoImg from "../assets/images/mszweb-logo1.png";
import "../assets/fonts/fonts.css";

const NavbarAbs = ({ visible }) => {
  return (
    <div className="relative">
      {/* Navbar */}
      <motion.nav
        initial={{ y: -100, opacity: 0 }} // Initially hidden and above the viewport
        animate={visible ? { y: 0, opacity: 1 } : { y: -100, opacity: 0 }} // Slide down/up based on the boolean
        transition={{ type: "spring", stiffness: 50, damping: 15, delay: 0.1 }}
        className="absolute w-2/3 top-0 left-10 z-10"
      >
        <div className="container mx-auto flex justify-between items-center py-5 px-6">
          {/* Logo and Navigation closer together */}
          <motion.div
            initial={{ y: -20, opacity: 0 }} // Initially hidden and above the viewport
            animate={visible ? { y: 0, opacity: 1 } : { y: -100, opacity: 0 }} // Slide down/up based on the boolean
            transition={{ type: "spring", stiffness: 50 }}
            className="flex items-center space-x-12 left-1/6" // Add space between logo and nav items
          >
            {/* Logo */}
            <motion.img
              key="logo"
              transition={{ type: "spring", stiffness: 60 }}
              whileHover={{ scale: 1.15 }}
              src={logoImg}
              alt="Logo"
              className="h-16 w-16 md:h-36 md:w-36 object-contain"
            />

            {/* Navigation Links */}
            <motion.ul
              key="navButtons"
              initial={{ opacity: 0 }} // Initially hidden and above the viewport
              animate={visible ? { opacity: 1 } : { opacity: 0 }} // Slide down/up based on the boolean
              transition={{ type: "spring", stiffness: 15 }}
              className="flex space-x-8 text-2xl"
            >
              {["Home", "Projects", "Extras", "Contact"].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ y: -40, opacity: 0 }} // Initially hidden and above the viewport
                  animate={
                    visible ? { y: 0, opacity: 1 } : { y: -40, opacity: 0 }
                  } // Slide down/up based on the boolean
                  transition={{
                    type: "spring",
                    stiffness: 40,
                    mass: 0.5,
                    delay: 0.3 + index / 8,
                  }}
                  className="-mx-1 px-1"
                >
                  <motion.li
                    key={index}
                    whileHover={{ scale: 1.1, color: "#D1D5DB" }}
                    transition={{ type: "spring", stiffness: 50, mass: 0.5 }}
                    className="relative group -mx-1 px-1" // Add a relative position to handle underline
                  >
                    <Link
                      to={`/${item.toLowerCase()}`}
                      className="text-white hover:text-gray-300 nsans-7-li"
                    >
                      {item}
                    </Link>
                    {/* Underline */}
                    <span className="absolute left-0 bottom-0 w-6 h-0.5 bg-gray-300 transition-all duration-300 group-hover:w-full"></span>
                  </motion.li>
                </motion.div>
              ))}
            </motion.ul>
          </motion.div>
        </div>
      </motion.nav>
    </div>
  );
};

export default NavbarAbs;
